import {Cart} from '../../../../models/acquista-servizi-models/cart';
import {Injectable} from '@angular/core';
import { Order } from 'src/app/models/acquista-servizi-models/order';
import { OrdersFilters } from 'src/app/models/acquista-servizi-models/ordersFilters';

@Injectable({
  providedIn: 'root'
})
export class OrdersStore {
  cart: Cart;
  atLeastOneItemInCartExists = false;

  orders: Array<Order>;
  autocompleteValues: Array<string>;

  totalOrdersNumber: number;
  pageNumber: number;
  pageSize = 15;
  filters: OrdersFilters;

  constructor() {
    this.pageNumber = 1;
    this.cart = new Cart();
    this.orders = [];
    this.autocompleteValues = [];
    this.filters = {
      username: '',
      isPaid: '',
      paymentMethod: ''
    };
  }

  loadOrders(orders: Order[], totalOrders: number) {
    this.orders = orders;
    this.totalOrdersNumber = totalOrders;
  }
  loadAutocompleteValues(usernames: Array<string>) {
    this.autocompleteValues = usernames;
  }

}
